import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import { usePlaceTypeName } from '../../../utils/helpers/placeTypes'
import { MultiSelectExportSubtitle } from './MultiSelectModalContent'

const ModalHeader = _props => {
  const { t } = useTranslation('export')
  const { entity, empty } = useModalData()
  let name = usePlaceTypeName(entity, true)
  if (!name) name = t('entity.' + entity)

  return (
    <>
      <Title size="h4" align="center" noMargin>
        {empty ? t('generateTemplate') : t('exportOf', { name })}
      </Title>
      {!empty && <MultiSelectExportSubtitle />}
    </>
  )
}

export default ModalHeader
